// eslint-disable-next-line no-undef
const version = __VOD_LOGGER_VERSION__
export default version
